'use strict';



export default class Hero {
	constructor() {
			
			if ($('.nav-special').length > 0){

			var activeSlide = $(".hero-holder .hero-txt");
			slideNo(activeSlide);


			//var slideId = $('.bg-holder > .bg').first().data('slide-id');
			//slideNo(slideId);	
	
			var height = "innerHeight" in window 
				   ? window.innerHeight
				   : document.documentElement.offsetHeight; 
			
			// START | Slide 1 - Pay yout fine  //
			
			if (height <= 900 && innerWidth >= 1025) {
				// Align background on 'y' on a widescreen 
				$('body').addClass('wideScreen');
			}
			
			if (innerWidth <= 768) {
				$('.fine-input').attr('placeholder', 'Reference number');
			}
			// END | Slide 1 - Pay yout fine  //
			
			$('.nav-btn.slide-1, .option-pay').on('click',function(){
				
				// Fade & slide out then change the page the user is on
				animate();
				
				if (innerWidth >= 1024) {
					// Show calculator on the desktop
					$('.slide-1_1').addClass('active');
				} 

				if (innerWidth >= 1025) {
					var href = this.href;
					changeSlide(href);
				}
			});
				
			$('.home .nav-special a, .menu__item:nth-child(1) .sub-menu a').on('click',function(){
				// Fade & slide out then change the page the user is on
				
				animate();
				
				if (innerWidth >= 1025) {
					var href = this.href;
					changeSlide(href);
				}
			});
			
			function changeSlide(href){
				event.preventDefault();
				$('.options .active').removeClass('active');
				$('.bg').removeClass('active');
				
				setTimeout(function(){window.location = href;}, 200);
			}
				
			function slideNo(sideId){
				$(sideId).addClass('active');
				$('.bg-holder .bg').addClass('active');
				if (innerWidth >= 1025) {$('.slide-1_1').addClass('active');}
		
				if (innerWidth <= 1025) {
					//Scroll to top on mobile
					$('html,body').animate({ scrollTop: 0 }, 'slow');
				}
				//$('.options .active').removeClass('active');

				$('.hero-holder .hero-txt, .bg-holder .bg').addClass('active');
				
				animate();
				
				// Is the calculator on?
				var cal = $('.options').hasClass('calculator-on');
				if (cal){$('.options').removeClass('calculator-on')}
				
				if($('.bg-holder .bg').hasClass('UseBlackYourFinesLink'))
				{
					$('.menu-container').addClass("black");
				} 
				else 
				{
					$('.menu-container').removeClass("black");
				}
				

			};
				
			function animate(){
				// Set bg posititon on wide screen
				if ( innerWidth >= 1240) {
					if ($('.bg').data('slide-bg-to-left') == true){
						$('.bg').css("left", "");
					} else {
						$('.bg').css("left", "");
						position();
					}
				} 
			}
				
			if (innerWidth <= 1024) {
				$('#show-options').on('click',function(){
					scrollTo('#show-options');
				});
				
			}
			
			function position(){
				var $screen = window.innerWidth,
					$gap = $screen - 1240,
					$position = ($screen - ($gap/2)) - 200 +"px";

				//$('.bg').css("left", $position);

			}
			
			function more(){
				$('.bg-holder, #more-info, .footer-container').addClass('more-activated');
				scrollTo("#more-info");
				
			}
				
			function scrollTo(target){
				var aTag = $(target);
				$('html,body').animate({
					scrollTop: aTag.offset().top
				},500);
			}
		}	
	}
}
